<template>
  <form
    class="form form--password-reset"
    method="post"
    @submit.prevent="submit"
  >
    <h1>{{ t('authentication.resetPasswordTitle') }}</h1>
    <div class="form-item">
      <input
        class="form-element form--password-reset__email"
        type="text"
        name="email"
        :placeholder="t('authentication.usernamePlaceholder')"
        :disabled="!canSubmit()"
        v-model="email"
      />
    </div>
    <div class="form--password-reset__messages" v-if="message">
      {{ message }}
    </div>
    <div class="form--password-reset__actions">
      <router-link class="password-reset-back" to="/login">{{ t('global.back') }}</router-link>
      <template v-if="!message">
        <LinkButton
          :icon-right="submitIcon"
          form="passwordReset"
          :text="t('login.resetPassword')"
          :disabled="!canSubmit()"
        />
      </template>
    </div>
  </form>
</template>

<script>
  import LinkButton from '@/components/LinkButton.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useAuthStore } from '@/stores/useAuthStore'
  import { useFormsStore } from '@/stores/useFormsStore'
  import Cookie from 'js-cookie'

  export default {
    name: 'form-password-reset',
    setup() {
        const authStore = useAuthStore()
        const formsStore = useFormsStore()
        const { t } = useStrings()
        return {
          t,
          authStore,
          formsStore,
        }
      },
    data: () => {
      return {
        email: '',
        submitted: false,
      }
    },
    components: {
      LinkButton,
    },
    computed: {
      message() {
        return !this.submitted
          ? undefined
          : this.t('authentication.passwordResetMailSent')
      },
      submitIcon() {
        return this.formsStore.getFormState('passwordReset') !== 'finished'
          ? 'Arrow'
          : 'Check'
      },
    },
    methods: {
      submit() {
        if (this.email.length < 8) {
          return
        }
        this.authStore.startPasswordReset(this.email)
        this.submitted = true
      },
      canSubmit() {
        const minTimeBetweenResets = 20
        const lastPasswordReset = Cookie.get('lastPasswordReset')
        if (!lastPasswordReset) {
          return true
        }
        const now = Math.floor(Date.now() / 1000)
        const secondsElapsed = now - lastPasswordReset
        return secondsElapsed > minTimeBetweenResets
      },
    },
  }
</script>

<style lang="scss">
  .form--password-reset {
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    transition: $transition-base;

    @media (min-height: 260px) {
      margin-top: 8vh;
    }

    @media (min-height: $bp-xs) {
      margin-top: 18vh;
    }

    &__messages {
      border: 2px solid $community;
      border-radius: $border-radius;
      line-height: $line-height-sm;
      padding: $spacer05 $spacer10;
      margin-bottom: $spacer10;
      white-space: pre-line;
    }

    &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .password-reset-back {
    cursor: pointer;
    transition: $transition-base;
  }
</style>
